import { useMutation, useQuery } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

interface GetFileRes {
  signedUrl: string
}

export function useGetVesselFileUrl({
  vesselId,
  sectionId,
  fileName,
}: {
  vesselId: string
  sectionId: string
  fileName: string
}) {
  const fetchRequest = useFetch<GetFileRes>()
  const url = `/vessels/${vesselId}/${sectionId}/${fileName}`
  return useQuery({
    queryKey: [url],
    queryFn: () => fetchRequest(`${apiBase()}${url}`),
    enabled: false,
  })
}

export function useDeleteVesselFiles() {
  const fetchRequest = useFetch()

  return useMutation({
    mutationFn: (fileNames: string[]) => {
      const deleteRequests = fileNames.map((fileName) => {
        const url = `/vessels/${fileName}`
        return fetchRequest(`${apiBase()}${url}`, {
          method: 'DELETE',
        })
      })
      return Promise.all(deleteRequests)
    },
  })
}
